import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/* =========================================================
   DATOS FALSOS
   ========================================================= */
const PISCINAS_DEMO = [
  { id: '1', codigo: 'Ps 01', sector: 'A.1', ha: 4.60 },
  { id: '2', codigo: 'Ps 02', sector: 'A.1', ha: 2.37 },
  { id: '3', codigo: 'Ps 03', sector: 'A.1', ha: 2.31 },
  { id: '4', codigo: 'Ps 04', sector: 'A.1', ha: 3.93 },
  { id: '5', codigo: 'Ps 05', sector: 'A.1', ha: 5.40 },
];

const MUESTREOS_DEMO = [
  { id: '1', piscina: 'Ps 02', sector: 'A.1', fecha: '05/10/2026 17:21', peso: 11.60, cant: 250, pct: '—' },
  { id: '2', piscina: 'Ps 04', sector: 'A.1', fecha: '04/10/2026 15:10', peso: 10.00, cant: 280, pct: 92 },
  { id: '3', piscina: 'Ps 01', sector: 'A.1', fecha: '03/10/2026 16:33', peso: 8.50, cant: 300, pct: 95 },
];

const PARAMETROS_DEMO = [
  { id: '1', piscina: 'Ps 01', sector: 'A.1', fecha: '08/10/2026 17:57', ox: 3.20, temp: 29.0 },
  { id: '2', piscina: 'Ps 02', sector: 'A.1', fecha: '08/10/2026 17:02', ox: 7.00, temp: 29.0 },
  { id: '3', piscina: 'Ps 04', sector: 'A.1', fecha: '08/10/2026 17:06', ox: 8.00, temp: 30.0 },
  { id: '4', piscina: 'Ps 05', sector: 'A.1', fecha: '08/10/2026 16:00', ox: 2.10, temp: 28.5 },
];

/* =========================================================
   COMPONENTE PRINCIPAL
   ========================================================= */
export default function DemoApp({ embebido = false }) {
  const navigate = useNavigate();
  const [pantalla, setPantalla] = useState('menu');
  const [historial, setHistorial] = useState([]);
  const [parametros, setParametros] = useState(PARAMETROS_DEMO);

  const irA = (p) => {
    setHistorial((h) => [...h, pantalla]);
    setPantalla(p);
  };

  const volver = () => {
    const prev = historial[historial.length - 1] || 'menu';
    setHistorial((h) => h.slice(0, -1));
    setPantalla(prev);
  };

  return (
    <div className={embebido ? '' : 'min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 flex flex-col items-center justify-center p-4 py-8'}>

      {/* Banner demo — solo si NO es embebido */}
      {!embebido && (
        <div className="w-full max-w-sm mb-3 flex items-center justify-between">
          <div className="bg-amber-400 text-amber-900 px-3 py-1 rounded-full text-xs font-bold shadow">
            🎬 MODO DEMO
          </div>
          <button
            onClick={() => navigate('/login')}
            className="text-xs text-slate-600 hover:text-slate-900 underline"
          >
            ← Volver al login
          </button>
        </div>
      )}

      {/* Banner mini si está embebido
      {embebido && (
        <div className="flex items-center justify-center gap-2 mb-2">
          <div className="bg-amber-400 text-amber-900 px-2 py-0.5 rounded-full text-[10px] font-bold">
            🎬 DEMO INTERACTIVO
          </div>
        </div>
      )}*/}

      {/* Marco del celular */}
      <div className={`w-full max-w-sm bg-white rounded-[2rem] shadow-2xl overflow-hidden border-8 border-slate-800 ${embebido ? 'mx-auto' : ''}`}>
        <div className="bg-slate-900 h-6 flex justify-center items-center">
          <div className="w-16 h-3 bg-slate-700 rounded-full"></div>
        </div>

        <div className={`${embebido ? 'h-[520px]' : 'h-[640px]'} overflow-y-auto bg-slate-50`}>
          {pantalla === 'menu' && <ScreenMenu irA={irA} />}
          {pantalla === 'mapeo' && <ScreenMapeo volver={volver} />}
          {pantalla === 'actividades' && <ScreenActividades volver={volver} />}
          {pantalla === 'muestreo_seleccion' && (
            <ScreenSeleccionPiscina
              volver={volver}
              titulo="Muestreo"
              icono="🧪"
              onSeleccionar={() => irA('muestreo_nuevo')}
            />
          )}
          {pantalla === 'muestreo_nuevo' && <ScreenNuevoMuestreo volver={volver} />}
          {pantalla === 'parametros' && (
            <ScreenParametrosHome
              volver={volver}
              onNuevo={() => irA('parametros_nuevo')}
              onVerHistorial={() => irA('parametros_historial')}
            />
          )}
          {pantalla === 'parametros_nuevo' && (
            <ScreenNuevoParametro
              volver={volver}
              onGuardar={(p) => {
                setParametros([p, ...parametros]);
                volver();
              }}
            />
          )}
          {pantalla === 'parametros_historial' && (
            <ScreenHistorialParametros volver={volver} parametros={parametros} />
          )}
          {pantalla === 'graficas' && <ScreenGraficas volver={volver} />}
        </div>
      </div>

      {!embebido && (
        <p className="mt-3 text-xs text-slate-500 text-center max-w-sm">
          Simulación interactiva de la app móvil Lluchunga · Sin conexión al servidor
        </p>
      )}
    </div>
  );
}

/* =========================================================
   PANTALLA: MENÚ PRINCIPAL
   ========================================================= */
function ScreenMenu({ irA }) {
  const hora = new Date().getHours();
  const saludo = hora < 12 ? 'Buenos días' : hora < 19 ? 'Buenas tardes' : 'Buenas noches';

  const modulos = [
    { id: 'mapeo',       icono: '🗺️', titulo: 'Mapeo',       subtitulo: 'Instalar equipos', color: 'bg-blue-100 text-blue-700 border-blue-200' },
    { id: 'actividades', icono: '📋', titulo: 'Actividades', subtitulo: 'Registrar alertas', color: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
    { id: 'muestreo_seleccion', icono: '🧪', titulo: 'Muestreo', subtitulo: 'Pesos de camarón', color: 'bg-green-100 text-green-700 border-green-200' },
    { id: 'parametros',  icono: '💧', titulo: 'Parámetros',  subtitulo: 'Oxígeno y temperatura', color: 'bg-cyan-100 text-cyan-700 border-cyan-200' },
    { id: 'graficas',    icono: '📈', titulo: 'Gráficas',    subtitulo: 'Crecimiento y parámetros', color: 'bg-purple-100 text-purple-700 border-purple-200' },
  ];

  return (
    <div className="bg-slate-50 min-h-full">
      <div className="bg-blue-800 text-white px-4 py-4">
        <div className="flex items-center justify-between mb-2">
          <div className="font-bold text-base">Administrador</div>
          <div className="text-lg">⎋</div>
        </div>
        <div className="text-[10px] text-blue-200">Panel de administración</div>
      </div>

      <div className="p-4">
        <div className="bg-green-50 border border-green-200 rounded-lg p-2.5 flex items-center gap-2 mb-4">
          <div className="text-green-600 text-sm">✓</div>
          <div className="text-xs text-green-800 font-medium flex-1">Conectado</div>
          <div className="bg-white text-[10px] px-2 py-0.5 rounded-full font-semibold text-slate-600">admin</div>
        </div>

        <div className="text-center mb-4">
          <div className="text-lg font-bold text-blue-900">{saludo}, Administrador 👋</div>
          <div className="text-xs text-slate-500 mt-0.5">¿Qué vamos a realizar hoy?</div>
        </div>

        <div className="space-y-2">
          {modulos.map((m) => (
            <button
              key={m.id}
              onClick={() => irA(m.id)}
              className={`w-full flex items-center gap-3 p-3 bg-white rounded-xl shadow-sm border-2 hover:shadow-md transition ${m.color}`}
            >
              <div className="w-12 h-12 rounded-xl bg-white/60 flex items-center justify-center text-2xl">
                {m.icono}
              </div>
              <div className="flex-1 text-left">
                <div className="font-bold text-sm text-slate-800">{m.titulo}</div>
                <div className="text-[11px] text-slate-500">{m.subtitulo}</div>
              </div>
              <div className="text-slate-400 text-sm">›</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

/* =========================================================
   PANTALLA: MAPEO
   ========================================================= */
function ScreenMapeo({ volver }) {
  return (
    <AppBarDemo titulo="Instalar equipo" subtitulo="Administrador" volver={volver}>
      <div className="p-4 space-y-3">
        <Field label="Sector *" value="Sector A.1" />
        <Field label="Piscina *" value="Ps 02" />
        <Field label="Tipo de equipo *" value="Alimentador" />
        <Field label="Tecnología *" value="Eruvaka" />
        <Field label="Nombre del equipo *" value="Alimentador #1" />
        <Field label="Código del alimentador *" value="ERU-001" />

        <div className="text-center text-xs text-slate-400 my-2">📍 Ubicación</div>

        <button className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-sm">
          📍 Usar mi ubicación GPS
        </button>

        <div className="grid grid-cols-2 gap-2">
          <Field label="Latitud *" value="-3.258100" />
          <Field label="Longitud *" value="-79.955300" />
        </div>

        <button className="w-full bg-blue-900 text-white py-3 rounded-xl font-bold text-sm mt-3">
          Guardar equipo
        </button>
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   PANTALLA: ACTIVIDADES
   ========================================================= */
function ScreenActividades({ volver }) {
  const items = [
    { fecha: '05/10/2026 · 12:37', piscina: 'Ps 01', tiempo: '1 h', estado: 'Resuelta', tipo: 'Mantenimiento correctivo' },
    { fecha: '05/10/2026 · 11:31', piscina: 'Ps 01', tiempo: '29 min', estado: 'Resuelta', tipo: 'Mantenimiento Preventivo' },
    { fecha: '05/10/2026 · 09:15', piscina: 'Ps 02', tiempo: '1 h 2 min', estado: 'Resuelta', tipo: 'Limpieza de sensores' },
    { fecha: '05/10/2026 · 08:55', piscina: 'Ps 01', tiempo: '1 h 13 min', estado: 'Resuelta', tipo: 'Cosecha' },
  ];

  return (
    <AppBarDemo titulo="Actividades" subtitulo="Administrador" volver={volver}>
      <div className="p-4 space-y-2">
        <div className="bg-green-50 border border-green-200 rounded-lg p-2.5 flex items-center gap-2 mb-3">
          <div className="text-green-600 text-sm">✓</div>
          <div className="text-xs text-green-800 font-medium">Conectado</div>
        </div>

        {items.map((a, i) => (
          <div key={i} className="bg-white rounded-xl p-3 shadow-sm flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-700">
              ✓
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-semibold text-slate-800">{a.fecha}</div>
              <div className="text-[11px] text-slate-500 mt-0.5">{a.piscina} · {a.tiempo}</div>
              <div className="text-[10px] text-slate-400 mt-0.5">{a.tipo}</div>
            </div>
            <div className="bg-green-100 text-green-800 text-[10px] px-2 py-0.5 rounded-full font-semibold">
              {a.estado}
            </div>
          </div>
        ))}

        <div className="flex justify-center pt-2">
          <button className="bg-blue-900 text-white text-sm px-4 py-2 rounded-full shadow-lg font-semibold">
            + Nueva actividad
          </button>
        </div>
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   PANTALLA: SELECCIÓN DE PISCINA
   ========================================================= */
function ScreenSeleccionPiscina({ volver, titulo, icono, onSeleccionar }) {
  return (
    <AppBarDemo titulo={titulo} subtitulo="Administrador" volver={volver}>
      <div className="p-4 space-y-3">
        <Field label="Sector" value="Sector A.1" />
        <div className="text-slate-400 text-xs">22 piscinas</div>

        <div className="space-y-2">
          {PISCINAS_DEMO.map((p) => (
            <button
              key={p.id}
              onClick={onSeleccionar}
              className="w-full flex items-center gap-3 p-3 bg-white rounded-xl shadow-sm hover:shadow-md transition"
            >
              <div className="text-cyan-600 text-xl">{icono}</div>
              <div className="flex-1 text-left">
                <div className="font-semibold text-sm text-slate-800">Piscina {p.codigo}</div>
                <div className="text-[11px] text-slate-500">{p.ha} ha</div>
              </div>
              <div className="text-slate-400 text-sm">›</div>
            </button>
          ))}
        </div>
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   PANTALLA: NUEVO MUESTREO
   ========================================================= */
function ScreenNuevoMuestreo({ volver }) {
  const [tipo, setTipo] = useState('peso');

  return (
    <AppBarDemo titulo="Piscina Ps 02" subtitulo="Administrador" volver={volver}>
      <div className="p-4 space-y-3">
        <div className="flex bg-slate-200 rounded-lg p-1">
          <button
            onClick={() => setTipo('peso')}
            className={`flex-1 py-2 text-xs font-semibold rounded-md ${tipo === 'peso' ? 'bg-blue-700 text-white shadow' : 'text-slate-600'}`}
          >
            ⚖️ Peso
          </button>
          <button
            onClick={() => setTipo('prepeso')}
            className={`flex-1 py-2 text-xs font-semibold rounded-md ${tipo === 'prepeso' ? 'bg-orange-500 text-white shadow' : 'text-slate-600'}`}
          >
            ⚖️ Prepeso
          </button>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-xl p-3 flex items-center gap-2">
          <div className="text-green-600">✓</div>
          <div className="flex-1">
            <div className="text-xs font-semibold text-green-900">Corrida activa asignada</div>
            <div className="text-[10px] text-green-700">Se asociará a la corrida más reciente</div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 shadow-sm flex items-center gap-2">
          <div className="text-slate-400">📅</div>
          <div className="flex-1">
            <div className="text-xs font-semibold text-slate-700">08/10/2026 17:30</div>
          </div>
          <div className="text-slate-400 text-xs">✎</div>
        </div>

        <div className="text-sm font-bold text-slate-700">Pesadas</div>

        <div className="bg-white rounded-xl p-3 shadow-sm">
          <div className="text-xs font-bold text-slate-700 mb-2">Pesada 1</div>
          <div className="grid grid-cols-2 gap-2">
            <Field label="Peso (g)" value="11.60" />
            <Field label="Cantidad" value="250" />
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-xl p-3">
          <div className="text-xs font-bold text-slate-700 mb-1">Resumen</div>
          <div className="text-[11px] text-slate-600">Suma de pesos: 2900.00 g</div>
          <div className="text-[11px] text-slate-600">Total animales: 250</div>
          <div className="text-[11px] font-semibold text-blue-900">Promedio: 11.60 g/animal</div>
        </div>

        <button className="w-full bg-blue-900 text-white py-3 rounded-xl font-bold text-sm">
          💾 Guardar muestreo
        </button>
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   PANTALLA: PARÁMETROS - HOME
   ========================================================= */
function ScreenParametrosHome({ volver, onNuevo, onVerHistorial }) {
  return (
    <AppBarDemo titulo="Parámetros" subtitulo="Administrador" volver={volver}>
      <div className="p-4 space-y-3">
        <div className="bg-green-50 border border-green-200 rounded-lg p-2.5 flex items-center gap-2">
          <div className="text-green-600 text-sm">✓</div>
          <div className="text-xs text-green-800 font-medium">Conectado</div>
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-md">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-700 text-xl">
              ✓
            </div>
            <div className="flex-1">
              <div className="text-sm font-bold text-slate-800">Pendientes de subir</div>
              <div className="text-[11px] text-slate-500">Todo sincronizado</div>
            </div>
            <div className="text-3xl font-bold text-green-700">0</div>
          </div>
        </div>

        <button
          onClick={onNuevo}
          className="w-full bg-cyan-700 text-white py-3 rounded-xl font-bold text-sm"
        >
          + Nuevo registro de parámetro
        </button>

        <button
          onClick={onVerHistorial}
          className="w-full border-2 border-cyan-700 text-cyan-700 py-3 rounded-xl font-bold text-sm"
        >
          📋 Ver historial y gráfica
        </button>
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   PANTALLA: NUEVO PARÁMETRO
   ========================================================= */
function ScreenNuevoParametro({ volver, onGuardar }) {
  const [ox, setOx] = useState('');
  const [temp, setTemp] = useState('');

  const estado = (() => {
    const v = parseFloat(ox);
    if (isNaN(v)) return null;
    if (v < 2.0) return { texto: '🔴 CRÍTICO',      color: 'bg-red-100 text-red-700' };
    if (v < 2.2) return { texto: '🟠 POSIBLE BAJA', color: 'bg-orange-100 text-orange-700' };
    if (v < 2.6) return { texto: '🟡 RECUPERANDO',  color: 'bg-amber-100 text-amber-700' };
    if (v < 2.8) return { texto: '🟢 ESTABLE',      color: 'bg-lime-100 text-lime-700' };
    return { texto: '✅ ÓPTIMO', color: 'bg-green-100 text-green-700' };
  })();

  const guardar = () => {
    const oxN = parseFloat(ox);
    const tempN = parseFloat(temp);
    if (isNaN(oxN) && isNaN(tempN)) return;

    onGuardar({
      id: String(Date.now()),
      piscina: 'Ps 02',
      sector: 'A.1',
      fecha: new Date().toLocaleString('es-EC'),
      ox: isNaN(oxN) ? null : oxN,
      temp: isNaN(tempN) ? null : tempN,
    });
  };

  return (
    <AppBarDemo titulo="Parámetros · Ps 02" subtitulo="Administrador" volver={volver}>
      <div className="p-4 space-y-3">
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-white rounded-xl p-3 shadow-sm">
            <div className="text-[10px] text-slate-500">Fecha</div>
            <div className="text-sm font-bold text-slate-800">08/10/2026</div>
          </div>
          <div className="bg-white rounded-xl p-3 shadow-sm">
            <div className="text-[10px] text-slate-500">Hora</div>
            <div className="text-sm font-bold text-slate-800">17:30</div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 shadow-sm">
          <div className="text-[10px] text-slate-500 mb-1">Oxígeno disuelto (mg/L) *</div>
          <div className="flex items-center gap-2">
            <input
              type="number"
              step="0.1"
              value={ox}
              onChange={(e) => setOx(e.target.value)}
              placeholder="Ej: 2.5"
              className="flex-1 border border-slate-300 rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
            />
            {estado && (
              <div className={`text-[10px] font-bold px-2 py-1 rounded ${estado.color}`}>
                {estado.texto}
              </div>
            )}
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 shadow-sm">
          <div className="text-[10px] text-slate-500 mb-1">Temperatura (°C)</div>
          <input
            type="number"
            step="0.1"
            value={temp}
            onChange={(e) => setTemp(e.target.value)}
            placeholder="Ej: 29.0"
            className="w-full border border-slate-300 rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
          />
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-[10px] text-slate-600 space-y-0.5">
          <div className="font-bold text-slate-700 mb-1">Umbrales configurados:</div>
          <div>🔴 Crítico: &lt; 2.00</div>
          <div>🟠 Barbeo: &lt; 2.20</div>
          <div>🟡 Recuperando: &lt; 2.60</div>
          <div>🟢 Estable: &lt; 2.80</div>
          <div>✅ Óptimo: ≥ 2.80</div>
        </div>

        <button
          onClick={guardar}
          disabled={!ox && !temp}
          className="w-full bg-cyan-700 text-white py-3 rounded-xl font-bold text-sm disabled:opacity-50"
        >
          💾 Guardar parámetro
        </button>
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   PANTALLA: HISTORIAL DE PARÁMETROS
   ========================================================= */
function ScreenHistorialParametros({ volver, parametros }) {
  const getEstado = (ox) => {
    if (ox == null) return null;
    if (ox < 2.0) return { texto: 'CRÍTICO',       color: 'bg-red-100 text-red-700' };
    if (ox < 2.2) return { texto: 'POSIBLE BAJA',  color: 'bg-orange-100 text-orange-700' };
    if (ox < 2.6) return { texto: 'RECUPERANDO',   color: 'bg-amber-100 text-amber-700' };
    if (ox < 2.8) return { texto: 'ESTABLE',       color: 'bg-lime-100 text-lime-700' };
    return { texto: 'ÓPTIMO', color: 'bg-green-100 text-green-700' };
  };

  return (
    <AppBarDemo titulo="Historial de parámetros" subtitulo="Administrador" volver={volver}>
      <div className="p-4 space-y-2">
        {parametros.length === 0 ? (
          <div className="text-center text-xs text-slate-500 py-10">Sin registros</div>
        ) : (
          parametros.map((p) => {
            const estado = getEstado(p.ox);
            return (
              <div key={p.id} className="bg-white rounded-xl p-3 shadow-sm">
                <div className="flex items-center justify-between mb-1">
                  <div className="text-xs font-bold text-slate-800">
                    {p.piscina} · {p.sector}
                  </div>
                  <div className="text-[10px] text-slate-400">{p.fecha}</div>
                </div>
                <div className="flex items-center gap-3 text-[11px]">
                  {p.ox != null && (
                    <div className="text-cyan-700 font-semibold">O₂: {p.ox.toFixed(2)} mg/L</div>
                  )}
                  {p.temp != null && (
                    <div className="text-orange-600 font-semibold">T°: {p.temp.toFixed(1)} °C</div>
                  )}
                </div>
                {estado && (
                  <div className={`inline-block mt-1 text-[10px] font-bold px-2 py-0.5 rounded ${estado.color}`}>
                    {estado.texto}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   PANTALLA: GRÁFICAS
   ========================================================= */
function ScreenGraficas({ volver }) {
  const [tab, setTab] = useState('crecimiento');

  return (
    <AppBarDemo titulo="Gráficas" subtitulo="Administrador" volver={volver} color="bg-purple-700">
      <div className="bg-purple-700 text-white">
        <div className="flex">
          <button
            onClick={() => setTab('crecimiento')}
            className={`flex-1 py-3 text-xs font-semibold flex items-center justify-center gap-1 border-b-2 ${tab === 'crecimiento' ? 'border-white' : 'border-transparent opacity-70'}`}
          >
            📈 Crecimiento
          </button>
          <button
            onClick={() => setTab('parametros')}
            className={`flex-1 py-3 text-xs font-semibold flex items-center justify-center gap-1 border-b-2 ${tab === 'parametros' ? 'border-white' : 'border-transparent opacity-70'}`}
          >
            💧 Parámetros
          </button>
        </div>
      </div>

      <div className="p-4 space-y-3">
        {tab === 'crecimiento' && (
          <>
            <div className="flex bg-slate-200 rounded-lg p-1">
              <button className="flex-1 py-1.5 text-xs font-semibold rounded bg-blue-700 text-white">⚖️ Peso</button>
              <button className="flex-1 py-1.5 text-xs font-semibold rounded text-slate-600">⚖️ Prepeso</button>
            </div>

            <div className="flex bg-slate-200 rounded-lg p-1">
              <button className="flex-1 py-1.5 text-xs font-semibold rounded bg-blue-700 text-white">📋 Historial</button>
              <button className="flex-1 py-1.5 text-xs font-semibold rounded text-slate-600">📈 Gráfica</button>
            </div>

            <div className="space-y-2">
              {MUESTREOS_DEMO.map((m) => (
                <div key={m.id} className="bg-white rounded-xl p-3 shadow-sm">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="text-[9px] font-bold bg-blue-100 text-blue-800 px-1.5 py-0.5 rounded">PESO</div>
                    <div className="text-xs font-bold text-slate-800">{m.piscina} · {m.sector}</div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 text-[11px]">
                    <div className="text-slate-500">📅 {m.fecha}</div>
                    <div className="text-slate-500">⚖️ {m.peso} g</div>
                    <div className="text-slate-500"># {m.cant} animales</div>
                    <div className="text-slate-500">% {m.pct}%</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {tab === 'parametros' && (
          <>
            <div className="flex bg-slate-200 rounded-lg p-1">
              <button className="flex-1 py-1.5 text-xs font-semibold rounded bg-purple-700 text-white">📋 Historial</button>
              <button className="flex-1 py-1.5 text-xs font-semibold rounded text-slate-600">📈 Gráfica</button>
            </div>

            <div className="bg-white rounded-xl p-3 shadow-sm">
              <div className="text-[10px] text-slate-500 mb-2">Sector A.1 · Ps 02</div>
              <div className="flex gap-2">
                <div className="w-3 h-3 rounded-sm bg-cyan-600"></div>
                <div className="text-[11px]">Oxígeno</div>
                <div className="w-3 h-3 rounded-sm bg-orange-500 ml-3"></div>
                <div className="text-[11px]">Temperatura</div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-3 shadow-sm">
              <div className="h-40 flex items-end justify-around gap-1 border-l border-b border-slate-200 pl-2 pb-1">
                {[3.2, 7.0, 8.0, 2.1, 5.5, 6.8, 4.3].map((v, i) => (
                  <div key={i} className="flex-1 flex flex-col items-center gap-1">
                    <div
                      className="w-full bg-cyan-600 rounded-t"
                      style={{ height: `${(v / 10) * 100}%` }}
                    ></div>
                    <div className="text-[8px] text-slate-400">d{i + 1}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-2">
              {PARAMETROS_DEMO.slice(0, 3).map((p) => (
                <div key={p.id} className="bg-white rounded-xl p-3 shadow-sm">
                  <div className="flex items-center justify-between mb-1">
                    <div className="text-xs font-bold text-slate-800">{p.piscina} · {p.sector}</div>
                    <div className="text-[10px] text-slate-400">{p.fecha}</div>
                  </div>
                  <div className="flex items-center gap-3 text-[11px]">
                    <div className="text-cyan-700 font-semibold">O₂: {p.ox.toFixed(2)}</div>
                    <div className="text-orange-600 font-semibold">T°: {p.temp.toFixed(1)}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </AppBarDemo>
  );
}

/* =========================================================
   COMPONENTES AUXILIARES
   ========================================================= */
function AppBarDemo({ titulo, subtitulo, volver, children, color = 'bg-blue-800' }) {
  return (
    <div className="min-h-full bg-slate-50">
      <div className={`${color} text-white px-4 py-3 flex items-center gap-3`}>
        <button onClick={volver} className="text-xl">←</button>
        <div className="flex-1">
          <div className="text-sm font-bold leading-tight">{titulo}</div>
          {subtitulo && <div className="text-[10px] text-blue-200 leading-tight">{subtitulo}</div>}
        </div>
      </div>
      {children}
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div className="bg-white rounded-lg border border-slate-300 px-3 py-2">
      <div className="text-[10px] text-slate-500">{label}</div>
      <div className="text-sm font-medium text-slate-800">{value}</div>
    </div>
  );
}